import apiClient from '../client'

export const getAccountCurrent = async (): Promise<{
  username: string
  email: string
  phone: string
  avatar: string
}> => {
  const response = await apiClient.post('/api/user/account/current')
  return response.data.data
}

export const updateUsername = async (newUsername: string): Promise<void> => {
  await apiClient.post('/api/user/setting/username/update', { newUsername })
}

export const sendEmailCode = async (email: string): Promise<void> => {
  await apiClient.post('/api/user/setting/email/code', { email })
}

export const updateEmail = async (email: string, emailCode: string): Promise<void> => {
  await apiClient.post('/api/user/setting/email/update', { email, emailCode })
}

export const sendPhoneCode = async (phone: string): Promise<void> => {
  await apiClient.post('/api/user/setting/phone/code', { phone })
}

export const updatePhone = async (phone: string, phoneCode: string): Promise<void> => {
  await apiClient.post('/api/user/setting/phone/update', { phone, phoneCode })
}

export const updateAvatar = async (avatar: string): Promise<void> => {
  await apiClient.post('/api/user/setting/avatar/update', { avatar })
}

export const updatePassword = async (oldPassword: string, newPassword: string): Promise<void> => {
  await apiClient.post('/api/user/setting/password/update', { oldPassword, newPassword })
}
